import { render, staticRenderFns } from "./BaseApp.vue?vue&type=template&id=1f32e5a2"
import script from "./BaseApp.vue?vue&type=script&lang=ts"
export * from "./BaseApp.vue?vue&type=script&lang=ts"
import style0 from "./BaseApp.vue?vue&type=style&index=0&id=1f32e5a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports